import { LicenseProvider, StudioProvider } from './state/StudioContext'

export default function App() {
  return (
    <LicenseProvider>
      <StudioProvider>
        <div className="flex min-h-screen items-center justify-center text-ink-100">
          <span className="text-sm text-ink-300">DemoPolish Studio</span>
        </div>
      </StudioProvider>
    </LicenseProvider>
  )
}
